import { Controller } from "@hotwired/stimulus"

import Modal from 'bootstrap/js/dist/modal';


export default class extends Controller {
  connect() {
    const paymentIntent = new URLSearchParams(window.location.search).get(
      'payment_intent'
    );

    if (paymentIntent) {
      // Update turbo-frame src to show success message
      const turboFrame = document.querySelector('#payment-success').querySelector('turbo-frame')
      turboFrame.src = `/payments/stripe/success/${paymentIntent}/`;
      new Modal(document.querySelector('#payment-success')).show()

      // Remove payment intent info from URL
      const url = new URL(window.location.href);
      url.searchParams.delete('payment_intent');
      url.searchParams.delete('payment_intent_client_secret');
      window.history.replaceState({}, document.title, url);

    }

  }
}
